import React from 'react';
import { StyledBadge, StyledTagBadgeDiv, TableData, TableRow } from "./StyledResultRow";


export const ResultRowTags = ( props) => {
    const { row, rowId, index, tags } = props;
    return (
        <TableRow
            id={ rowId }
            className={ `description ${ row.type === "resource" ? "extra-padding" : "" } ${ index % 2 === 0 ? "even" : "odd" } ` }
        >
            <TableData colSpan={ 7 } className={ "accordionWrapper" }>
                <StyledTagBadgeDiv>
                    { tags.map ( ( tag, index ) => <StyledBadge
                        key={ tag.entity.entityLabel + index }
                        bsPrefix="badge badge-info badge-small">{ tag.entity.entityLabel }</StyledBadge> ) }
                </StyledTagBadgeDiv>
            </TableData>
        </TableRow>
    );
}
